import React from 'react';
import { Typography, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@src/components/Tooltip';
import { StyledPackageInfoRow } from './index.style';

const PackageInfoRow = ({
  label,
  value,
  showTooltip = false,
  tooltipContent,
  isBold = false,
  isMobile = false,
  onTooltipClick,
}) => {
  const labelFontSize = isMobile ? '12px' : '14px';
  const valueFontSize = isMobile ? '14px' : '16px';

  return (
    <StyledPackageInfoRow>
      <div className="row-content">
        <Typography
          className="label"
          sx={{
            fontSize: labelFontSize,
            lineHeight: isMobile ? '16px' : '20px',
          }}
        >
          {label}
        </Typography>
        <div className="value-container">
          <Typography
            className="value"
            sx={{
              fontSize: valueFontSize,
              fontWeight: isBold ? 700 : 400,
              lineHeight: isMobile ? '20px' : '24px',
              color: '#000000',
            }}
          >
            {value}
          </Typography>
          {showTooltip && tooltipContent && (
            <Tooltip title={tooltipContent} arrow placement="top">
              <IconButton
                onClick={onTooltipClick}
                size="small"
                sx={{ padding: 0 }}
              >
                <InfoOutlinedIcon className="tooltip-icon" />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
    </StyledPackageInfoRow>
  );
};

export default PackageInfoRow;
